export const FIND_ASSIGNABLE_PRODUCT_ROUTINES = `
  query FindAssignableRoutinesForProduct($filter: FindAssignableProductRoutinesFilter!, $page: PageRequest, $orderBy: OrderByInput) {
    product {
      findAssignableRoutinesForProduct(filter: $filter, page: $page, orderBy: $orderBy) {
        count
        limit
        offset
        items { id name inAssignments }
      }
    }
  }
`;
